import React from 'react';
import './styles.module.scss';
import { useApp } from '../../../../context/app';
import { IncluirCanaisDigitais } from './IncluirCanaisDigitais';
import { GerenciarCanaisDigitais } from './GerenciarCanaisDigitais';

export const CanaisDigitais = () => {
  const { renderIncludeScreen } = useApp();
  return renderIncludeScreen ? (
    <IncluirCanaisDigitais />
  ) : (
    <GerenciarCanaisDigitais />
  );
};
